"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VARIANT = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const next_components_icon_1 = __importStar(require("@gerenciatd/next.components.icon"));
const next_components_text_info_1 = __importStar(require("@gerenciatd/next.components.text-info"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
exports.VARIANT = {
    DEFAULT: 'DEFAULT',
    WITH_BORDERS: 'WITH_BORDERS',
};
const FaqItem = ({ faqTitle, faqContent, isOpen, taggingInfo, options, variant, segment, index, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isFaqShow, setIsFaqShow] = (0, react_1.useState)(!!isOpen);
    const [chevronOptions, setChevronOptions] = (0, react_1.useState)({
        color: options.default.color.icon,
    });
    const [titleOptions, setTitleOptions] = (0, react_1.useState)({
        color: options.default.color.title,
    });
    const displayAnswerStatusCss = isFaqShow
        ? 'faq-item__chevron-icon--opened'
        : 'faq-item__chevron-icon';
    const displayContentCss = isFaqShow
        ? 'faq-item__content--opened'
        : 'faq-item__content';
    const curentTaggingInfo = Object.assign(Object.assign({}, taggingInfo), { componentProduct: `faqItem-${index}`, componentContent: isFaqShow ? 'faq-plegar' : 'faq-desplegar', componentVariation: 'none', eventType: 'click' });
    const onClickItem = () => {
        if (isFaqShow) {
            setIsFaqShow(false);
            setTitleOptions(Object.assign(Object.assign({}, titleOptions), { color: options.default.color.title }));
            setChevronOptions(Object.assign(Object.assign({}, chevronOptions), { color: options.default.color.icon }));
        }
        else {
            setIsFaqShow(true);
            setTitleOptions(Object.assign(Object.assign({}, titleOptions), { color: options.activated.color.title }));
            setChevronOptions(Object.assign(Object.assign({}, chevronOptions), { color: options.activated.color.icon }));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("li", { className: `faq-item ${variant === exports.VARIANT.DEFAULT
                ? 'faq-item--with-bottom-border'
                : 'faq-item--with-borders'}` },
            react_1.default.createElement(next_components_custom_link_1.default, { onClick: onClickItem, title: "FAQ-item", taggingInfo: curentTaggingInfo, className: "card-clickable" },
                react_1.default.createElement("div", { className: "faq-item__header" },
                    react_1.default.createElement(next_components_text_info_1.default, { text: faqTitle, kind: next_components_text_info_1.TEXT_INFO_KIND.HEADING, level: 3, align: next_components_text_info_1.TEXT_INFO_ALIGN.LEFT, color: titleOptions.color, size: next_components_text_info_1.TEXT_INFO_SIZE.TITLE45, fontType: next_components_text_info_1.TEXT_INFO_FONT_WEIGHT.REGULAR, className: "faq-item__title", segment: segment }),
                    react_1.default.createElement("span", { className: displayAnswerStatusCss },
                        react_1.default.createElement(next_components_icon_1.default, { id: next_components_icon_1.ICON_ID.CheuronDown, kind: next_components_icon_1.ICON_KIND.MEDIUM, size: 16, color: chevronOptions.color, segment: "emp", layoutSize: {
                                h: 16,
                                w: 16,
                            } })))),
            react_1.default.createElement("div", { className: displayContentCss },
                react_1.default.createElement(next_components_text_info_1.default, { text: faqContent, color: next_components_text_info_1.TEXT_INFO_COLOR.GREY_6, size: next_components_text_info_1.TEXT_INFO_SIZE.TITLE5, segment: segment }),
                react_1.default.createElement("hr", null)))));
};
FaqItem.propTypes = {
    /**
     * {
     * "info": "Booleano que nos permite abrir la pregunta po defecto"
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    isOpen: prop_types_1.default.bool,
    /**
     * {
     * "info": "Titulo de la pregunta frecuente/faq,"
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    faqTitle: prop_types_1.default.string.isRequired,
    /**
     * {
     * "info": "Respuesta de la  pregunta frecuente/faq. Es el texto que aparece cuando clickas sobre el titulo de cada  pregunta frecuente/faq.",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    faqContent: prop_types_1.default.string.isRequired,
    /**
     * {
     * "info": "Etiqueta de seguimiento para analitica",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    taggingInfo: prop_types_1.default.object.isRequired,
    /**
     * {
     * "info": "Opciones para cambiar los colores de cada pregunta frecuente/faq",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    options: prop_types_1.default.shape({
        /**
         * {
         * "info": "Cuando la pregunta frecuente/faq está sin abrir",
         * "kind": "both",
         * "beautifulName": "",
         * "injectComponent": ""
         * }
         */
        default: prop_types_1.default.shape({
            color: prop_types_1.default.shape({
                title: prop_types_1.default.oneOf(Object.values(next_components_text_info_1.TEXT_INFO_COLOR)),
                icon: prop_types_1.default.oneOf(Object.values(next_components_icon_1.ICON_COLOR)),
            }),
        }).isRequired,
        /**
         * {
         * "info": "Cuando la pregunta frecuente/faq está abierta",
         * "kind": "both",
         * "beautifulName": "",
         * "injectComponent": ""
         * }
         */
        activated: prop_types_1.default.shape({
            color: prop_types_1.default.shape({
                title: prop_types_1.default.oneOf(Object.values(next_components_text_info_1.TEXT_INFO_COLOR)),
                icon: prop_types_1.default.oneOf(Object.values(next_components_icon_1.ICON_COLOR)),
            }),
        }),
    }).isRequired,
    /**
     * {
     * "info": "Dependiendo del tipo de "variant" se cambian los estilos del componente. Es un modificador",
     * "kind": "both",
     * "beautifulName": "",
     * "injectComponent": ""
     * }
     */
    variant: prop_types_1.default.oneOf(Object.values(exports.VARIANT)).isRequired,
    // Icon: PropTypes.func.isRequired,
    /**
     * {
     *  "info": "Necesita para especificar el segmento",
     *  "kind": "both",
     *  "beautifulName": "Segmento"
     * }
     */
    segment: prop_types_1.default.oneOf((0, next_components_icon_1.convertToOptions)(next_components_text_info_1.TEXT_INFO_SEGMENT)),
};
FaqItem.defaultProps = {
    segment: next_components_text_info_1.TEXT_INFO_SEGMENT.GP,
    isOpen: false,
};
exports.default = FaqItem;
//# sourceMappingURL=index.js.map